const formatKey = key => key.replace(/\W/g, '_')

export function setLocalStorage(key, value) {
  localStorage.setItem(formatKey(key), value)
}

export function getLocalStorage(key) {
  return localStorage.getItem(formatKey(key))
}

export function removeLocalStorage(key) {
  localStorage.removeItem(formatKey(key))
}
export function textLink(str) {
  let txt1 = ''
  let txt2 = ''
  let txt = ''
  let arr = []
  if (!str) return str
  const textInfo = str
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, (a, b, c) => {
      arr.push({
        url: c,
        txt: b
      })
      return '-division-'
    })
    .split('-division-')
  let leng = arr.length - textInfo.length > 0 ? arr.length : textInfo.length
  for (var i = 0; i < leng; i++) {
    if (textInfo[i]) {
      txt1 = textInfo[i]
    } else {
      txt1 = ''
    }
    if (arr[i]) {
      txt2 = `<a target="_blank" href='${arr[i].url}'>${arr[i].txt}</a>`
    } else {
      txt2 = ''
    }
    txt += txt1 + txt2
  }
  return txt
}
export default {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  textLink
}



//////////////////
// WEBPACK FOOTER
// ./src/storeUtil.js
// module id = null
// module chunks = 